<template>
  <div class="ibox">
    <div class="ibox-title" v-if="title">
      <h5>{{title}}</h5>
      <div class="ibox-tools">
        <slot name="tools" />
      </div>
    </div>
    <div class="ibox-content">
      <slot name="content" />
    </div>
  </div>
</template>

<script>
export default {
  name: "ContentBox",
  props: {
    title: String,
    loading: {
      type: Boolean,
      default: false
    }
  }
};
</script>